export default "__VITE_ASSET__B4I_SzPn__";